import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {
  Box,
  Checkbox,
  Divider,
  Radio,
  Slider,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import StatusChip from "../chips/status.chip";
import { useAuth } from "../../context/auth.context";
import { votePoll } from "../../api/poll.api";
import PollIcon from '@mui/icons-material/Poll';

const PollCard = ({ poll }) => {
  const auth = useAuth();
  const [maxValue, setMaxValue] = useState(0);

  useEffect(() => {
    if (poll) {
      let lengths = poll.options.map((option) => option.userIds.length);
      let max = Math.max(...lengths);
      setMaxValue(max);
    }
  }, [poll]);

  const onChange = (option) => {
    votePoll(poll.id, option.index);
  };

  const isChecked = (option) => {
    if (!auth && !auth.user) {
      return false;
    }
    let userId = auth.user.id;
    return option.userIds.includes(userId);
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minWidth: 200,
        minHeight: 350,
        maxHeight: 350,
      }}
    >
      <CardContent>
        <Stack spacing={1} direction="row" sx={{ alignItems: "center", mb: 1 }}>
          <PollIcon />
          <StatusChip status={poll.status}/>
          <Typography variant="h6" color="primary" sx={{ mr: 1 }} gutterBottom>
            {poll.question}
          </Typography>
        </Stack>

        <Divider />
        <TableContainer>
          <Table>
            <TableBody>
              {poll.options.map((option, index) => (
                <TableRow
                  key={"poll_option_" + option.index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>
                    <Stack
                      spacing={2}
                      direction="row"
                      sx={{ alignItems: "center" }}
                    >
                      <Slider
                        sx={{ width: "150px" }}
                        value={option.userIds.length}
                        step={1}
                        marks
                        min={0}
                        max={maxValue}
                        size="small"
                        disabled
                      />

                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary" }}
                      >
                        {option.userIds.length}
                      </Typography>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {poll.status == "Open" && !poll.isSingleChoice && (
                        <Checkbox
                          size="small"
                          checked={isChecked(option)}
                          onClick={() => onChange(option)}
                        />
                      )}
                      {poll.status == "Open" && poll.isSingleChoice && (
                        <Radio
                          size="small"
                          checked={isChecked(option)}
                          onClick={() => onChange(option)}
                        />
                      )}
                      <Typography>{option.name} </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default PollCard;
